// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Ui__CascadeController from "./ui/cascade_controller"
application.register("ui--cascade", Ui__CascadeController)

import Ui__ComboboxController from "./ui/combobox_controller"
application.register("ui--combobox", Ui__ComboboxController)

import Ui__DisclosureController from "./ui/disclosure_controller"
application.register("ui--disclosure", Ui__DisclosureController)

import Ui__DismissController from "./ui/dismiss_controller"
application.register("ui--dismiss", Ui__DismissController)

import Ui__DropdownController from "./ui/dropdown_controller"
application.register("ui--dropdown", Ui__DropdownController)

import Ui__ModalController from "./ui/modal_controller"
application.register("ui--modal", Ui__ModalController)

import Ui__RemoteToggleController from "./ui/remote_toggle_controller"
application.register("ui--remote-toggle", Ui__RemoteToggleController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)

import Ui__TooltipController from "./ui/tooltip_controller"
application.register("ui--tooltip", Ui__TooltipController)

import Ui__TurboModalController from "./ui/turbo_modal_controller"
application.register("ui--turbo-modal", Ui__TurboModalController)
